import { createUseStyles, Styles } from 'react-jss';

export default createUseStyles((theme: Styles) => ({
  titleWidgetType: {
    color: theme.indigo3
  }
}));
